<template>
  <VueFragment>
    <span>{{ title }}</span>
    <div class="social-media">
      <b-link href="https://www.linkedin.com/in/james-choi-62810a44/" target="_blank">
        <font-awesome-icon :icon="['fab', 'linkedin-in']" size="2x"/>
      </b-link>
      <b-link class="icon-social-middle" href="https://github.com/choiboi" target="_blank">
        <font-awesome-icon :icon="['fab', 'github']" size="2x"/>
      </b-link>
      <b-link href="mailto:james.choi@mail.utoronto.ca">
        <font-awesome-icon icon="at" size="2x"/>
      </b-link>
    </div>
  </VueFragment>
</template>

<script>
import { Fragment as VueFragment } from 'vue-fragment';

export default {
  name: 'SocialMediaFooter',
  components: {
    VueFragment
  },
  props: {
    title: String
  }
}
</script>

<style lang="scss" scoped>
span {
  font-size: 18px;
  font-weight: bolder;
}

.social-media {
  margin-top: 10px;

  svg {
    color: white;

    &:hover {
      color: $primaryGreen;
    }
  }

  .icon-social-middle {
    margin-left: 30px;
    margin-right: 30px;
  }
}
</style>
